import { useCallback } from 'react';

import { hasHeroMatch } from '../../../telemetry/hero';
import type { ReportHeroComponentRendered } from '../context';

import type { UsePageLoadTelemetryCallbackOptions } from './usePageLoadTelemetryCallback';
import { usePageLoadTelemetryCallback } from './usePageLoadTelemetryCallback';

type UseReportHeroComponentRenderedCallbackOptions = UsePageLoadTelemetryCallbackOptions & {
  readonly onHeroComponentRendered: () => void;
};

export type UseReportHeroComponentRenderedCallback = (
  options: UseReportHeroComponentRenderedCallbackOptions
) => ReportHeroComponentRendered;

export const useReportHeroComponentRenderedCallback: UseReportHeroComponentRenderedCallback = ({
  onHeroComponentRendered,
  ...options
}) => {
  'use memo';

  const pageLoadTelemetryCallback = usePageLoadTelemetryCallback(options);

  const { hero } = options;

  return useCallback(
    (component, heroOptions) => {
      if (hasHeroMatch(component, hero)) {
        onHeroComponentRendered();
      }
      pageLoadTelemetryCallback(component, heroOptions);
    },
    [hero, pageLoadTelemetryCallback, onHeroComponentRendered]
  );
};
